import { corporateMenuItems, corporateRoutes } from 'pages/corporate/config';
import { merchantMenuItems, merchantRoutes } from 'pages/merchant/config';
import { mediaMenuItems, mediaRoutes } from 'pages/media/config';
import { commonsMenuItems, commonsRoutes } from 'pages/commons/config';
import { BarChartIcon } from 'lucide-react'; // or wherever you import icons from

export function getMenuAndRoutes(licenseType = '') {
  let licenseMenuItems = [];
  let licenseRoutes = [];

  switch (licenseType) {
    case 'merchant':
      licenseMenuItems = merchantMenuItems;
      licenseRoutes = merchantRoutes;
      break;
    case 'media':
      licenseMenuItems = mediaMenuItems;
      licenseRoutes = mediaRoutes;
      break;
    case 'commercial':
      licenseMenuItems = corporateMenuItems;
      licenseRoutes = corporateRoutes;
      break;
    case 'commons':
      licenseMenuItems = commonsMenuItems;
      licenseRoutes = commonsRoutes;
      break;
    default:
      licenseMenuItems = [];
      licenseRoutes = [];
  }

  const menuItems = {
    id: 'allMenuItems',
    type: 'group',
    children: [
      {
        id: 'dashboard',
        title: 'menu.dashboard',
        type: 'item',
        url: '/dashboard/default',
        icon: BarChartIcon,
        breadcrumbs: false,
        feature_code: 'personalization'
      },
      ...licenseMenuItems
    ]
  };

  return {
    menuItems: { items: [menuItems] },
    routes: licenseRoutes
  };
}
